import React from 'react'
import Card from '@mui/material/Card'
import CardActionArea from '@mui/material/CardActionArea'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import SchoolIcon from '@mui/icons-material/School'
import PsychologyIcon from '@mui/icons-material/Psychology'
import { PERSONAS } from './config'
import { TCAIREMStyle } from '../styles'

const PERSONA_ICONS = { educator: SchoolIcon, learner: PsychologyIcon }

/**
 * "I'm an educator" / "I'm a learner" cards. The selected card darkens;
 * clicking the other card swaps the selection (mockup behaviour).
 */
const PersonaToggle = ({ selected, onSelect }) => {
    return (
        <Grid container spacing={2}>
            {PERSONAS.map(persona => {
                const Icon = PERSONA_ICONS[persona.key]
                const isSelected = selected === persona.key
                return (
                    <Grid item xs={12} md={6} key={persona.key}>
                        <Card sx={{
                            ...TCAIREMStyle.personaCard,
                            ...(isSelected ? TCAIREMStyle.personaCardSelected : {}),
                        }}>
                            <CardActionArea onClick={() => onSelect(persona.key)} sx={TCAIREMStyle.personaCardArea}>
                                <Typography variant='h6' component='p'>{persona.label}</Typography>
                                <Icon sx={TCAIREMStyle.personaIcon} />
                                <Typography>{persona.subtitle}</Typography>
                            </CardActionArea>
                        </Card>
                    </Grid>
                )
            })}
        </Grid>
    )
}

export default PersonaToggle
